import "./ChemicalProcessingSuccessCase.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Engineering from "./sections/Engineering";
import Efficiency from "./sections/Efficiency";
import Safetycompliancecta from "./sections/Safetycompliancecta";
import Footer from "@/reusable_sections/Footer";
export default function ChemicalProcessingSuccessCasePage() {
  return <div>
      <Header />
      <Hero />
      <Engineering />
      <Efficiency />
      <Safetycompliancecta />
      <Footer />
    </div>;
}